import { getCoprincipalAccountSourcesByBootState, BootState } from 'owa-account-source-list-store';
import { logUsage } from 'owa-analytics';
import { isPstFileMailboxInfo } from 'owa-client-types/lib/PstFileMailboxInfo';
import { type FeatureName, isFeatureEnabled } from 'owa-feature-flags';

export enum DiagnosticsFeature {
    Feedback = 'feedback',
    InAppSupport = 'inappsupport',
    GetDiagnostics = 'getdiagnostics',
}

export function getAggregateFeedbackSupportFeatureFlag(
    diagnosticsFeature: DiagnosticsFeature
): boolean {
    if (isFeatureEnabled('mon-diag-enableAggregateDiagnsoticsFeatureFlagCheck')) {
        const accounts = getCoprincipalAccountSourcesByBootState(BootState.StartupComplete).filter(
            account => !isPstFileMailboxInfo(account.mailboxInfo)
        );
        let featureFlight: FeatureName = 'mon-diag-feedbackjs';
        switch (diagnosticsFeature) {
            case DiagnosticsFeature.Feedback:
                featureFlight = 'mon-diag-feedbackjs';
                break;

            case DiagnosticsFeature.InAppSupport:
                featureFlight = 'mon-diag-inappsupport';
                break;

            case DiagnosticsFeature.GetDiagnostics:
                featureFlight = 'mon-diag-getDiagnostics';
                break;
        }

        let isDiagnosticsFeatureEnabled = true; // true by default

        /* eslint-disable-next-line owa-custom-rules/forbid-foreach-with-variables-outside-of-function-scope -- (https://aka.ms/OWALintWiki)
         * https://dev.azure.com/outlookweb/Outlook%20Web/_wiki/wikis/Outlook%20Web.wiki/9650/Use-for-const-loop-of-instead-of-forEach
         *	> When using a forEach function call, avoid using variables outside of the scope of the function, use for (const item of array) instead
         *	> When using a forEach function call, avoid using variables outside of the scope of the function, use for (const item of array) instead */
        accounts.forEach(account => {
            const mailboxInfo = account.mailboxInfo;

            isDiagnosticsFeatureEnabled =
                /* eslint-disable-next-line owa-custom-rules/require-undefined-parameter -- (https://aka.ms/OWALintWiki)
                 * Flight checks that supply MailboxInfo should be defined as AccountFeatureName value and should be checked using isAccountFeatureEnabled to ensure consistent checking.
                 *	> The parameter mailboxInfo must be undefined. Feature flight: featureFlight */
                isDiagnosticsFeatureEnabled && isFeatureEnabled(featureFlight, mailboxInfo);
            /* eslint-disable-next-line owa-custom-rules/telemetry-mailboxinfo-as-second-param, owa-custom-rules/forbid-specific-functions-patterns-inside-loops -- (https://aka.ms/OWALintWiki)
             * BASELINE: DO NOT COPY/PASTE!
             * undefined
             *	> Argument at index 1 for logUsage must be of type MailboxInfo and not undefined. Telemetry calls that violate this rule will eventually be removed by the framework team. https://aka.ms/owa-analytics-mailboxinfo
             (https://aka.ms/OWALintWiki)
                         * Baseline. Dev touching this file must update to pass the active MailboxInfo; Docs: https://aka.ms/owa-analytics-mailboxinfo
                         * undefined
                         *	> MailboxInfo must be passed into the function to identify the account.
                         (https://aka.ms/OWALintWiki)
                                     * Baseline, this function can't be used inside a loop, please move it outside
                                     *	> Function 'logUsage' matches forbidden pattern (/logUsage/) and should not be used inside loops */
            logUsage('DiagnosticsAndSupport_IsDiagnosticsFeatureFlagEnabled', undefined, {
                accountType: mailboxInfo.type,
                isFeedbackFeatureFlagEnabled: isDiagnosticsFeatureEnabled,
                entrypoint: diagnosticsFeature,
                /* eslint-disable-next-line owa-custom-rules/require-undefined-parameter -- (https://aka.ms/OWALintWiki)
                 * Flight checks that supply MailboxInfo should be defined as AccountFeatureName value and should be checked using isAccountFeatureEnabled to ensure consistent checking.
                 *	> The parameter mailboxInfo must be undefined. Feature flight: featureFlight */
                isFeedbackFlightEnabled: isFeatureEnabled(featureFlight, mailboxInfo),
            });
        });

        return isDiagnosticsFeatureEnabled;
    }

    return false;
}
